import React from 'react';
import { FiBookOpen, FiX } from 'react-icons/fi';

import './MenuViewer.css';

const MenuViewer = ({ label, title, image, alt, className = 'btn btn--secondary' }) => {
  const dialogRef = React.useRef(null);

  const open = () => dialogRef.current.showModal();
  const close = () => dialogRef.current.close();
  const closeOnBackdrop = (event) => {
    if (event.target === dialogRef.current) close();
  };

  return (
    <>
      <button type="button" className={className} onClick={open}>
        <FiBookOpen aria-hidden="true" />
        {label}
      </button>
      {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
      <dialog ref={dialogRef} className="menu-viewer" aria-label={title} onClick={closeOnBackdrop}>
        <div className="menu-viewer__bar">
          <p>{title}</p>
          <a href={image.src} className="text-link menu-viewer__full" target="_blank" rel="noopener noreferrer">
            Ingrandisci
          </a>
          <button type="button" className="menu-viewer__close" onClick={close} aria-label="Chiudi il menù">
            <FiX aria-hidden="true" />
          </button>
        </div>
        <div className="menu-viewer__body">
          <img src={image.src} width={image.width} height={image.height} alt={alt} loading="lazy" />
        </div>
      </dialog>
    </>
  );
};

export default MenuViewer;
